import { render } from "./TalkToMyDataInvocationAdmin.vue?vue&type=template&id=4865740f&scoped=true"
import script from "./TalkToMyDataInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocationAdmin.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocationAdmin.vue?vue&type=style&index=0&id=4865740f&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4865740f"]])

export default __exports__